import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const InteractiveVideoWidgetStaticSchema = BaseWidgetSchema(WidgetType.InteractiveVideo).extend({
  src: z.string(),
  title: z.string(),
  defaultStopPointWidth: z.number(),
  stopPoints: z.record(
    z.string(),
    z.object({
      id: z.string(),
      label: z.string(),
      seconds: z.number(),
      width: z.number()
    })
  )
});

export type InteractiveVideoWidgetStaticSchemaType = z.infer<typeof InteractiveVideoWidgetStaticSchema>;
